import { Box, IconButton, useTheme } from '@mui/material';
import React, { FC } from 'react';

import { Icon } from '../Icon/Icon';
import { Typography } from '../Typography/Typography';

export interface QuantitySelectorV2Props {
  value: number;
  onChange: (value: number) => void;
  isDisabled: boolean;
  isDecrementDisabled?: boolean;
  isIncrementDisabled?: boolean;
  toggleDecrementIcon?: boolean;
}

export const QuantitySelectorV2: FC<QuantitySelectorV2Props> = ({
  value,
  onChange,
  isDisabled,
  isDecrementDisabled = false,
  isIncrementDisabled = false,
  toggleDecrementIcon = true,
}) => {
  const theme = useTheme();

  const handleSubtract = () => {
    onChange(value - 1);
  };

  const handleAdd = () => {
    onChange(value + 1);
  };

  const renderIconButton = (
    name: string,
    onClick: () => void,
    disabled?: boolean
  ) => (
    <IconButton onClick={onClick} disabled={disabled} size="small">
      <Icon
        name={name}
        fill={
          disabled
            ? theme.palette.action.disabledBackground
            : theme.palette.primary.main
        }
        size="medium"
      />
    </IconButton>
  );

  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      border={`1px solid ${theme.palette.grey[400]}`}
      borderRadius={0.8}
      p={0.5}
      width={109}
      height={44}
    >
      <>
        {renderIconButton(
          value === 1 && toggleDecrementIcon
            ? 'trash-2-outline'
            : 'minus-outline',
          handleSubtract,
          isDecrementDisabled || isDisabled
        )}
        <Typography variant="subtitle1">{value}</Typography>
        {renderIconButton(
          'plus-outline',
          handleAdd,
          isIncrementDisabled || isDisabled
        )}
      </>
    </Box>
  );
};
